import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import App from './App.vue'
import './registerServiceWorker'
import '@/icons'
import '@/validations'
import router from './router'
import firebaseConfig from './firebaseConfig.json'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import moment from 'moment'
import VueAutosuggest from 'vue-autosuggest'

import '@/plugins/vSelectConfig'

Vue.config.productionTip = false

// Initialize Firebase
const app = initializeApp(firebaseConfig)
getAnalytics(app)

Vue.use(BootstrapVue)
Vue.use(VueAutosuggest)

Vue.mixin({
  methods: {
    moment
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
